export function validateVoiceEnrollment(samples: Float32Array, durationMs: number): void {
  if (durationMs < 3000 || durationMs > 8000) throw new Error('Cada muestra debe durar entre 3 y 8 segundos.');
  if (samples.length !== Math.round(durationMs * 16)) throw new Error('Duración de audio no válida.');
  let squares = 0;
  let clipped = 0;
  for (const sample of samples) {
    if (!Number.isFinite(sample)) throw new Error('Audio no válido.');
    squares += sample * sample;
    if (Math.abs(sample) >= 0.995) clipped++;
  }
  const rms = Math.sqrt(squares / samples.length);
  if (rms < 0.012) throw new Error('Muestra demasiado silenciosa.');
  if (clipped / samples.length > 0.02) throw new Error('Muestra saturada; vuelve a grabar.');
}

export function validateSpeakerEmbedding(embedding: number[]): number[] {
  if (embedding.length !== 192 || embedding.some(value => !Number.isFinite(value))) throw new Error('Huella vocal local no válida.');
  return embedding;
}

export function enrollmentReady(consent: boolean, count: number): boolean { return consent && count === 3; }
